/** Truncate without throwing on null/undefined API fields. */
export const truncate = (text, maxLength) => {
  const value = String(text ?? "");
  return value.length > maxLength ? `${value.slice(0, maxLength)}...` : value;
};

/** Round a 0-100 rating for display; returns null when there are no votes. */
export const percent = (value) =>
  Number.isFinite(value) && value > 0 ? Math.round(value) : null;
